import { ReportStatus } from 'app/area/my-downloads/reports-view/types-store';

export const ACTION = {
  REQUEST_REPORT_STATUS: 'REPORTS:REQUEST_REPORT_STATUS',
  RECEIVE_REPORT_STATUS: 'REPORTS:RECEIVE_REPORT_STATUS',
  FAIL_REPORT_STATUS: 'REPORTS:FAIL_REPORT_STATUS',
  REQUEST_DOWNLOAD_REPORT_PACKAGE: 'REPORTS:REQUEST_DOWNLOAD_REPORT_PACKAGE',
  RECEIVE_DOWNLOAD_REPORT_PACKAGE: 'REPORTS:RECEIVE_DOWNLOAD_REPORT_PACKAGE',
  FAIL_DOWNLOAD_REPORT_PACKAGE: 'REPORTS:FAIL_DOWNLOAD_REPORT_PACKAGE'
};

export class RequestReportStatus {
  public type: string = ACTION.REQUEST_REPORT_STATUS;
}

export class ReceiveReportStatus {
  public type: string = ACTION.RECEIVE_REPORT_STATUS;
  public reportStatus: ReportStatus[];

  constructor(reportStatus: ReportStatus[]) {
    this.reportStatus = reportStatus;
  }
}

export class FailReportStatus {
  public type: string = ACTION.FAIL_REPORT_STATUS;
}

export class RequestDownloadReportPackage {
  public type: string = ACTION.REQUEST_DOWNLOAD_REPORT_PACKAGE;
  public reportId: string;

  constructor(reportId: string) {
    this.reportId = reportId;
  }
}

export class ReceiveDownloadReportPackage {
  public type: string = ACTION.RECEIVE_DOWNLOAD_REPORT_PACKAGE;
  public reportId: string;

  constructor(reportId: string) {
    this.reportId = reportId;
  }
}

export class FailDownloadReportPackage {
  public type: string = ACTION.FAIL_DOWNLOAD_REPORT_PACKAGE;
  public reportId: string;

  constructor(reportId: string) {
    this.reportId = reportId;
  }
}
